<script>
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {useDeclarationCotisationStore} from "@/stores/Impression/DeclarationCotisation";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import {computed, watch} from "vue";

export default {
    name: "ContributionDeclarations",
    props: {
        type: String,
    },
    setup(props) {
        const {total, loading, filter} = useSharedData();
        const {$i18n, $router} = useTools();
        
        const declarationCotisationStore = useDeclarationCotisationStore();
        const securityStore = useSecurityStore();
        
        filter.value.allRecords = true;
        
        const headers = [
            {
                text: "...",
                align: "left",
                sortable: true,
                value: "action"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                sortable: true,
                value: "code",
            },
            {
                text: $i18n.t('contribution_declaration.nature'),
                align: "left",
                sortable: true,
                value: "nature",
            },
            {
                text: $i18n.t('contribution_declaration.plate'),
                align: "left",
                sortable: true,
                value: "assiete",
            },
            {
                text: $i18n.t('contribution_declaration.rate'),
                align: "left",
                sortable: true,
                value: "taux",
            },
            {
                text: $i18n.t('contribution_declaration.contribution'),
                align: "left",
                sortable: true,
                value: "cotisation",
            },
            {
                text: $i18n.t('contribution_declaration.contribution_by_rate'),
                align: "left",
                sortable: true,
                value: "staticCotisation",
            },
        ];
        
        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/contributionDeclarations', {params: {type: props.type}}).then((response) => {
                declarationCotisationStore.setDeclarationCotisations(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        const rootPath = computed(() => {
            switch (props.type) {
                case 'DECLARATION_COTISATION':
                    return 'contribution_declarations';
                case 'DECLARATION_COTISATION_OLD':
                    return 'contribution_declarations_old';
                case 'DECLARATION_COTISATION_CACOBATH':
                    return 'contribution_declarations_cacobath';

            }
        });

        watch(filter, () => {
            findAll();
        }, {deep: true, immediate: true});


        return {
            rootPath,
            declarationCotisationStore,
            securityStore,
            headers,
            total,
            loading,
            filter,
            actions,
            findAll,
        };
    },
}
</script>

<template>
    <div>
        <v-container fluid>
            <w-btn-add
                :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                @press="$router.push({name: `${rootPath}.add`})"
            />
        </v-container>
        <w-data-table
            :headers="headers"
            :actions="actions"
            :items="declarationCotisationStore.declarationCotisations"
            :loading="loading"
            disable-pagination
        >
            <template v-slot:[`item.assiete`]="{ item }">
                <span v-if="!item.staticCotisation">{{ item.assiete }}</span>
            </template>
            <template v-slot:[`item.taux`]="{ item }">
                <span v-if="!item.staticCotisation">{{ item.taux }}</span>
            </template>
            <template v-slot:[`item.cotisation`]="{ item }">
                <span v-if="item.staticCotisation">{{ item.cotisation }}</span>
            </template>
            <template v-slot:[`item.staticCotisation`]="{ item }">
                <v-simple-checkbox :value="!item.staticCotisation" color="blue"/>
            </template>
        </w-data-table>
    </div>
</template>

<style scoped>

</style>